const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_USER_KEY = 'auth_user';
const AUTH_RETURN_PATH_KEY = 'auth_return_path';

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function getAuthUser() {
  return localStorage.getItem(AUTH_USER_KEY);
}

export function setAuthSession(token, user) {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, user);
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  // Clear any per-user UI state that could leak to the next user
}

export function rememberAuthReturnPath(path) {
  const returnPath = path || (typeof window !== 'undefined'
    ? `${window.location.pathname}${window.location.search}${window.location.hash}`
    : '');
  if (returnPath.startsWith('/') && !returnPath.startsWith('//') && !returnPath.startsWith('/login')) {
    sessionStorage.setItem(AUTH_RETURN_PATH_KEY, returnPath);
  }
}

export function consumeAuthReturnPath() {
  const returnPath = sessionStorage.getItem(AUTH_RETURN_PATH_KEY);
  sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
  return returnPath && returnPath.startsWith('/') && !returnPath.startsWith('//') && !returnPath.startsWith('/login')
    ? returnPath
    : null;
}

export function isTokenExpired(token = getAuthToken()) {
  if (!token) return true;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return true;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    return !payload?.exp || (payload.exp * 1000) <= Date.now();
  } catch {
    return true;
  }
}

export function getAuthHeaders(extraHeaders = {}) {
  const token = getAuthToken();
  return token
    ? { Authorization: `Bearer ${token}`, ...extraHeaders }
    : { ...extraHeaders };
}
